// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1LabelSchema } from './v1/labelSchema';
import { v1LabelsUpdateSchema } from './v1/labels/updateSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1ValidationErrorSchema } from './v1/validationErrorSchema';

export const updateTagPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.number().int().describe("Label ID"),
});

export const updateTagHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Label updated successfully
 */
export const updateTag200Schema = z.lazy(() => v1LabelSchema);

/**
 * @description Label not found
 */
export const updateTag404Schema = z.lazy(() => v1NotFoundErrorSchema);

/**
 * @description Validation failed - invalid data
 */
export const updateTag422Schema = z.lazy(() => v1ValidationErrorSchema);

export const updateTagMutationRequestSchema = z.lazy(() => v1LabelsUpdateSchema);

export const updateTagMutationResponseSchema = z.lazy(() => updateTag200Schema);
